var resources_filters = ( function( $ ) {

	var $filters;

	var $search_inputs;

	var $search_button;

	var submission_url;

	var $filtered_by;

	var _init = function() {
		_setup_toggle();
		_setup_select2_fields();
		_setup_search();
		_setup_clear_filters();
	};

	var _setup_toggle = function() {
		$filters = $( '.resources-filters' );

		if ( $filters.length > 0 ) {
			$filters.find( 'a.filter-toggle' ).on( 'click', function( e ) {
				e.preventDefault();
				var $this = $( this );

				var opening = ! $this.hasClass( 'toggled' );

				// Close others first if opening
				var $opened = $filters.find( '.toggled' );

				if ( opening && $opened.length > 0 ) {
					_toggle_dropdown( $opened );

					setTimeout( function() {
						_toggle_dropdown( $this )
					}, 300 )
				} else {
					_toggle_dropdown( $this )
				}
			} );
		}
	};

	var _toggle_dropdown = function( $dropdown_toggle ) {
		$dropdown_toggle.toggleClass( 'toggled' );
		$dropdown_toggle.parent().find( '.filter-dropdown' ).slideToggle();
	}

	var _setup_select2_fields = function() {
		$search_inputs = $filters.find( '.resources-filters-input' );

		if ( $search_inputs.length > 0 ) {
			$search_inputs.each( function() {
				var $this = $( this );

				$this.select2( {
					placeholder: $this.attr( 'data-placeholder' ),
				} );

				// Add class to select2 field so we can style inputs individually with CSS
				var $select2 = $this.next();
				$select2.addClass( 'select2-' + $this.attr( 'data-type' ) );

				// Do this in JS to fix issue with select 2 placeholders cutting off if the element is hidden on init
				var $dropdown = $this.closest( '.filter-dropdown' );
				$dropdown.attr( 'hidden', true );
			} );

			$search_inputs.on( 'change', _on_select2_select );
		}
	};

	var _on_select2_select = function( e ) {
		$( ".select2-selection__choice" ).addClass( "blue-select2-choice" );
	};

	var _setup_search = function() {
		$search_button = $filters.find( '.search-button' );

		if ( $search_button.length > 0 && $search_inputs.length > 0 ) {
			$search_button.on( 'click', _handle_search );
		}
	};

	var _setup_clear_filters = function() {
		$filtered_by = $( '.filtered-by' );

		if ( $filtered_by.length > 0 ) {
			var $clear_single = $filtered_by.find( '.clear-single' );

			if ( $clear_single.length > 0 ) {
				$clear_single.on( 'click', _handle_clear_single );
			}

			var $clear_all = $filtered_by.parent().find( '.clear-all' );

			if ( $clear_all.length > 0 ) {
				$clear_all.on( 'click', _handle_clear_all );
			}
		}
	}

	var _handle_search = function( e ) {
		e.preventDefault();

		_update_submission_url();

		window.location.href = submission_url;
	};

	var _update_submission_url = function( to_remove = false ) {

		var search_data = {
			profession: [],
			keyword: [],
			resource_type: [],
			category: []
		};

		if ( $filtered_by.length > 0 ) {
			var $filtered_terms = $filtered_by.find( '.filtered-term' );

			$filtered_terms.each( function( index ) {
				var $this = $( this );

				var term = $this.attr( 'data-term' );
				var tax  = $this.attr( 'data-tax' );

				if ( search_data[ tax ] ) {
					search_data[ tax ].push( term );
				}
			} );
		}

		$search_inputs.each( function() {
			var $this = $( this );

			var select2_data = $this.select2( 'data' );
			var key          = $this.attr( 'data-type' );

			for ( let i = 0; i < select2_data.length; i++ ) {
				search_data[ key ].push( select2_data[ i ].id );
			}
		} );

		if ( to_remove ) {
			var index = search_data[ to_remove.key ].indexOf( to_remove.id );
			search_data[ to_remove.key ].splice( index, 1 );
		}

		var url                = $filters.data( 'base-url' );
		var begun_query_string = false;

		Object.keys( search_data ).forEach( function( key ) {
			if ( search_data[ key ].length > 0 ) {
				if ( begun_query_string ) {
					url += '&';
				} else {
					begun_query_string = true;
					url += '?';
				}

				url += `${ key }=`;

				for ( let i = 0; i < search_data[ key ].length; i++ ) {
					url += search_data[ key ][ i ];
					if ( i != search_data[ key ].length - 1 ) {
						url += ',';
					}
				}
			}
		} );

		submission_url = url;
	};

	var _handle_clear_single = function( e ) {
		e.preventDefault();

		var $parent = $( this ).parent();

		var term = $parent.attr( 'data-term' );
		var tax  = $parent.attr( 'data-tax' );

		_update_submission_url( { key: tax, id: term } );

		window.location.href = submission_url;
	};

	var _handle_clear_all = function( e ) {
		e.preventDefault();

		var url = $filters.data( 'base-url' );

		window.location.href = url;
	};

	if ( $( '.resources-filters' ).length > 0 ) {
		_init();
	}

} )( jQuery );

module.exports = resources_filters;